import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { Table, Button, Container, Divider, Grid, Confirm, Dimmer, Loader } from 'semantic-ui-react'
import PlaceholderSegment from '../../../../components/generic/PlaceholderSegment';
import CategoryFormModal from './CategoryFormModal';

import * as QUESTIONNAIRE_ACTIONS from "../../../../actions/questionaireActions";
import * as QUESTION_ACTIONS from "../../../../actions/questionActions";
import * as CATEGORY_ACTIONS from '../../../../actions/marketPlaceCategoryActions';
import * as LOOKUPQNAIRE_ACTIONS from '../../../../actions/lookupsQnaireActions';

export function MarketPlaceCategoriesPage(props) {
	const [state, setState] = useState({
		isEditCategoryOpen: false,
		selectedCategory: {},
		showConfirmDelete: false,
		deleteCandidate: {}
	});

	const hasPermissions = (category) => {
		return !_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty(category)
	}

	const isAdmin = () => {
		return hasPermissions('Other') && props.userPermissions['Other'].actions.admin
	}

	const canReadCategory = () => {
		return hasPermissions('Market Place Categories') && props.userPermissions['Market Place Categories'].actions.READ || isAdmin()
	}

	const canCreateCategory = () => {
		return hasPermissions('Market Place Categories') && canReadCategory() && props.userPermissions['Market Place Categories'].actions.CREATE || isAdmin()
	}

	const canUpdateCategory = () => {
		return hasPermissions('Market Place Categories') && canReadCategory() && props.userPermissions['Market Place Categories'].actions.UPDATE || isAdmin()
	}

	const canDeleteCategory = () => {
		return hasPermissions('Market Place Categories') && canReadCategory() && props.userPermissions['Market Place Categories'].actions.DELETE || isAdmin()
	}

	useEffect(() => {
		if (props.isPermissionsFetched && props.questionaire?.id) {
			if (canReadCategory()) {
				props.fetchLookupsAction(props.tenant);
				props.fetchCategoriesAction(props.questionaire.id, props.questionaire.tenantId);
				props.fetchQuestionnaireQuestionsAction(props.questionaire.id, null, props.questionaire.tenantId);
			}
			else {
				toast.error('You do not have permission to view market place categories');
			}
		}
	}, [props.isPermissionsFetched, props.questionaire?.id, props.questionaire?.tenantId])

	const isBaseQnaire = props.questionaire.isBaseQnaire;
	const isRootTenant = props.tenant.isRoot === true || false;

	const onCategorySelectionChanged = (rowId) => {
		if (rowId !== 'new') {
			const categories = props.categories.filter(x => x.id === rowId);
			if (categories.length > 0) {
				const category = categories[0];
				setState((state) => ({
					...state,
					selectedCategory: category
				}));
			}
			else {
				setState((state) => ({
					...state,
					selectedCategory: {}
				}));
			}
		}
		else {
			setState((state) => ({
				...state,
				selectedCategory: {
					id: 0,
					name: ''
				}
			}));
		}
	}

	const onEditCategoryRow = (rowId) => {
		onCategorySelectionChanged(rowId)
		setState((state) => ({ ...state, isEditCategoryOpen: true }));
	}

	const onSaveCategory = (categoryData) => {
		const isQuestionnaireActive = props.questionaire.status == "active" || props.questionaire.status == "underReview";

		if (isQuestionnaireActive) {
			props.deactiveQuestionaireAction(props.questionaire);
		}

		if (categoryData.id === 0 || !categoryData.id) {
			const toCommit = _.omit(categoryData, ['id']);
			toCommit.questionaireId = props.questionaire.id;
			toCommit.status = 'active';
			props.saveCategoryAction(toCommit, props.questionaire.tenantId);
		} else {
			props.saveCategoryAction(categoryData, props.questionaire.tenantId);
		}

		setState((state) => ({ ...state, isEditCategoryOpen: false, selectedCategory: {} }));
	}

	const confirmDeleteCategory = () => {
		let contentMessage = "The questionnaire is currently active or under review. Editing any part of the questionnaire will result in its deactivation, requiring it to undergo the review process again.";
		return (
			<Confirm
				content={contentMessage}
				open={state.showConfirmDeleteCategory}
				onCancel={() => setState((state) => ({ ...state, showConfirmDeleteCategory: false, }))}
				onConfirm={() => {
					setState((state) => ({ ...state, showConfirmDeleteCategory: false, confirmDeleteCategoryFinal: true }));
				}
				}
			/>
		);
	}

	const deleteCategoryFinal = () => {
		return (
			<Confirm
				content={`Are you sure you want to delete the following category: ${state.deleteCandidate.name}?`}
				open={state.confirmDeleteCategoryFinal}
				onCancel={() => setState((state) => ({ ...state, confirmDeleteCategoryFinal: false, }))}
				onConfirm={() => {
					var deleteCategory = state.deleteCandidate;
					props.deactiveQuestionaireAction(props.questionaire);
					props.deleteCategoryAction(deleteCategory);
					onCategorySelectionChanged(0);
					setState((state) => ({ ...state, confirmDeleteCategoryFinal: false }));
				}
				}
			/>
		);
	}

	const confirmDelete = () => {
		return (
			<Confirm
				content={`Are you sure you want to delete the following category: ${state.deleteCandidate.name}?`}
				open={state.showConfirmDelete}
				onCancel={() => setState((state) => ({ ...state, showConfirmDelete: false, }))}
				onConfirm={() => {
					var deleteCategory = state.deleteCandidate;
					props.deleteCategoryAction(deleteCategory);
					onCategorySelectionChanged(0);
					setState((state) => ({ ...state, showConfirmDelete: false }));
				}
				}
			/>
		);
	}

	const getLookupName = (lookupId) => {
		const lookup = props.lookups.find(l => l.id === lookupId);
		return lookup ? lookup.name : 'Unknown';
	}

	const getUsedLookups = () => {
		if (_.isEmpty(props.questions)) return [];

		const usedLookupIds = new Set();
		props.questions.forEach(question => {
			if (question.lookupId) {
				usedLookupIds.add(question.lookupId);
			}
		});

		return props.lookups.filter(lookup => usedLookupIds.has(lookup.id));
	};

	const categoryItems = () => {
		if (!props.fetchingData) {
			if (!_.isEmpty(props.categories)) {
				props.categories.sort((a, b) => a.name.localeCompare(b.name));

				return (
					<Table compact selectable size='small'>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell className='nectaPrimaryBg'>Market Place Category Name</Table.HeaderCell>
								<Table.HeaderCell className='nectaPrimaryBg'>Lookup Menu</Table.HeaderCell>
								<Table.HeaderCell className='nectaPrimaryBg' />
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{props.categories.map(category => {
								return (
									<Table.Row key={category.id} className='clickable' onClick={() => onCategorySelectionChanged(category.id)} active={category.id === state.selectedCategory.id}>
										<Table.Cell>{category.name}</Table.Cell>
										<Table.Cell>{getLookupName(category.lookupId)}</Table.Cell>
										<Table.Cell textAlign='right'>
											{canUpdateCategory() && (!isBaseQnaire || (isBaseQnaire && isRootTenant)) && (
												<Button compact className='warning' icon='edit' size='mini' onClick={(e) => { e.stopPropagation(); onEditCategoryRow(category.id) }} />
											)}
											{canDeleteCategory() && (!isBaseQnaire || (isBaseQnaire && isRootTenant)) && (
												<Button compact className='danger' icon='trash' size='mini' onClick={(e) => {
													e.stopPropagation();
													const isQuestionnaireActive = props.questionaire.status == "active" || props.questionaire.status == "underReview";
													if (isQuestionnaireActive) {
														setState((state) => ({ ...state, deleteCandidate: category, showConfirmDeleteCategory: true }));
													} else {
														setState((state) => ({ ...state, deleteCandidate: category, showConfirmDelete: true }));
													}
												}} />)}
										</Table.Cell>
									</Table.Row>
								);
							})
							}
						</Table.Body>
					</Table>
				);
			}
			else {
				return (
					<PlaceholderSegment text="There are no market place categories yet" />
				);
			}
		}
		else {
			return (
				<div style={{ height: "200px", margin: "10px 0px" }}>
					<Dimmer inverted active>
						<Loader content='Loading' />
					</Dimmer>
				</div>
			);
		}
	}

	return (
		<Container fluid>
			{confirmDelete()}
			{confirmDeleteCategory()}
			{deleteCategoryFinal()}
			<Grid>
				<Grid.Row>
					<Grid.Column width='8'>
						<h3>Market Place Categories</h3>
					</Grid.Column>
					<Grid.Column width='8'>
						{canCreateCategory() && (!isBaseQnaire || (isBaseQnaire && isRootTenant)) && (
							<Button compact size='mini' icon='add' className='success' floated='right' onClick={(e) => { e.stopPropagation(); onEditCategoryRow('new') }} />
						)}
					</Grid.Column>
				</Grid.Row>
			</Grid>

			<CategoryFormModal
				open={state.isEditCategoryOpen}
				category={state.selectedCategory}
				lookups={getUsedLookups()}
				onSave={onSaveCategory}
				onCancel={() => setState({ ...state, isEditCategoryOpen: false, selectedCategory: {} })}
			/>

			{categoryItems()}
		</Container>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		fetchingData: state.fetchingData > 0,
		categories: _.isEmpty(state.categories) ? [] : _.orderBy(Object.values(state.categories).filter(category => category.questionaireId === ownProps.questionaire.id), ['name']),
		questions: _.isEmpty(state.questions) ? [] : state.questions,
		lookups: _.isEmpty(state.lookups) ? [] : state.lookups,
		tenant: state.tenantManagement.activeTenant,
		userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions,
		isPermissionsFetched: state.isPermissionsFetched === true,
	};
}

export default connect(
	mapStateToProps,
	(dispatch, ownProps) => ({
		fetchCategoriesAction: (questionaireId, tenantId) => dispatch(CATEGORY_ACTIONS.fetchCategoriesAction(questionaireId, tenantId)),
		fetchQuestionnaireQuestionsAction: (questionaireId, none, tenantId) => dispatch(QUESTION_ACTIONS.fetchQuestionsAction(questionaireId, none, tenantId)),
		fetchLookupsAction: (questionaireId, tenantId) => dispatch(CATEGORY_ACTIONS.fetchLookupsAction(questionaireId, tenantId)),
		deactiveQuestionaireAction: (questionaire) => dispatch(QUESTIONNAIRE_ACTIONS.deactiveQuestionaireAction(questionaire)),
		saveCategoryAction: (category, tenantId) => dispatch(CATEGORY_ACTIONS.categorySaveAction(category, tenantId)),
		deleteCategoryAction: (category) => dispatch(CATEGORY_ACTIONS.categoryDeleteAction(category)),
	})
)(MarketPlaceCategoriesPage);
